import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import moment from 'moment';
import { moduli } from '../../config';
import { ZahtjeviZaSirovineService } from './zahtjevi-za-sirovine.service';
import { PregledIzdatniceService } from '../pregled-izdatnice/pregled-izdatnice.service';

@Component({
  selector: 'app-zahtjevi-za-sirovine',
  templateUrl: './zahtjevi-za-sirovine.component.html',
  styleUrls: ['./zahtjevi-za-sirovine.component.scss'],
})
export class ZahtjeviZaSirovineComponent implements OnInit {
  zahtjevi: any = [];
  sirovine: [] = [];
  idSmjena: number;
  formatHours = 'HH:mm';
  sada = moment();
  datumOd = moment();
  datumDo = moment();
  datumOd_za_slanje = moment().format('YYYY-MM-DD');
  datumDo_za_slanje = moment().format('YYYY-MM-DD');
  poruka: string;
  disableGumb: boolean = false;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  naslov: string;
  odabranoSkladiste_id: any;
  sviArtikli_poslovnica: any = [];
  sviLotovi_poslovnica: any = [];
  sviLotovi_artikla: any = [];

  constructor(private service: ZahtjeviZaSirovineService, private izdatniceService: PregledIzdatniceService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    this.onShowing = this.onShowing.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().pregledZahtjevaZaSirovine;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    //console.log(e);
    this.datumOd = e.value;
    this.datumOd_za_slanje = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.datumOd_za_slanje + " " + this.datumDo_za_slanje);
  }

  onValueChangedDatumDo(e) {
    //console.log(e);
    this.datumDo = e.value;
    this.datumDo_za_slanje = moment(e.value).format('YYYY-MM-DD');
    //console.log(this.datumOd_za_slanje + " " + this.datumDo_za_slanje);
  }

  pretrazi(){
    this.dohvatiZahtjeve();
  }

  dohvatiZahtjeve(): void {
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.zahtjevi = [];
    let sat06 = moment('06:00', this.formatHours);
    let sat14 = moment('14:00', this.formatHours);
    let sat22 = moment('22:00', this.formatHours);
    if (this.sada.isBetween(sat06, sat14)) {
      this.idSmjena = 1;
    }
    if (this.sada.isBetween(sat14, sat22)) {
      this.idSmjena = 2;
    }
    if (this.sada.isBetween(sat22, sat06)) {
      this.idSmjena = 3;
    }
    //console.log(this.idSmjena);
    //console.log(this.datumOd_za_slanje);
    //console.log(this.datumDo_za_slanje);
    this.service.dohvatiZahtjeve({idsmjena: this.idSmjena, datumOd: this.datumOd_za_slanje, datumDo: this.datumDo_za_slanje}).subscribe((res)=>{
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        //this.zahtjevi = res.data;
        for (let data of res.data) {
          this.zahtjevi.push({
            ar_naziv: data.ar_naziv,
            artikl_ar_id: data.artikl_ar_id,
            firma_idfirma: data.firma_idfirma,
            idzahtjevsirovinezag: data.idzahtjevsirovinezag,
            li_naziv: data.li_naziv,
            linija_idlinija: data.linija_idlinija,
            name: data.name,
            nl_broj: data.nl_broj,
            po_sifra: data.po_sifra,
            poslovnica_idposlovnica: data.poslovnica_idposlovnica,
            poslovnica_idposlovnica_ambalaza: data.poslovnica_idposlovnica_ambalaza,
            poslovnica_idposlovnica_gotovo: data.poslovnica_idposlovnica_gotovo,
            rnalozi_nl_id: data.rnalozi_nl_id,
            smjena: data.smjena_idsmjena,
            vrijemeizmjene: data.vrijemeizmjene,
            vrijemepodnosenjazahtjeva: data.vrijemepodnosenjazahtjeva,
            vrsta: data.vrsta,
            zahtjevpredao: data.zahtjevpredao,
            zsz_status: data.zsz_status
          });
        }
      }
      if (res.data.length > 0) {
        this.poruka = 'Učitavanje...';
      }else{
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  kreirajIzdatnicu(e: any) {
    //console.log(e);
    const sirovine = [];
    const stavke = [];
    this.service
      .dohvatiStavke({
        idzahtjevsirovinezag: e.data.idzahtjevsirovinezag,
        posifra: e.data.po_sifra,
        idfirma: e.data.firma_idfirma,
      })
      .subscribe((res) => {
        if (res.success === true) {
          for (let sirovina of res.data) {
            sirovine.push({
              artikl_ar_id: sirovina.artikl_ar_id,
              bar_kod: null,
              ns_kolicina: sirovina.zss_kolicina_edit,
              arlot: sirovina.zss_ar_lot,
            });
            stavke.push({
              idzahtjevsirovinastavke: sirovina.idzahtjevsirovinastavke,
              posifra: e.data.po_sifra,
              idfirma: e.data.firma_idfirma,
            });
          }
        }
      })
      .add(() => {
        const data = {
          posifra: e.data.po_sifra,
          idfirma: e.data.firma_idfirma,
          idradninalog: e.data.rnalozi_nl_id,
          iduser: Number(localStorage.getItem('idsecuser')),
          sirovine: sirovine,
          stavke: stavke,
        };
        //console.log(data);
        //console.log('sirovine: ', sirovine);
        let prazanLot = false;
        for (let data of sirovine) {
          //console.log('data: ', data);
          if (data.arlot === null) {
            prazanLot = true;
            break;
          }
        }
        if (!prazanLot) {
          //console.log(prazanLot);
          this.service.kreirajIzdatnicu(data).subscribe((res) => {
            //console.log(res);
            if (res.success === true) {
              this.dohvatiZahtjeve();
              notify('Uspješno kreirana izdatnica.', 'success', 3000);
            }
          });
        } else {
          notify('Neke od stavki nemaju upisan LOT!', 'warning', 3000);
        }
      });
  }

  obrisiZahtjevPovrat(e: any) {
    //console.log(e);
    let myDialog = custom({
      title: "Brisanje",
      messageHtml: "Jeste li sigurni da želite obrisati <b>" + e.data.vrsta + "</b>?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if(dialogResult.buttonText === 'DA'){
        this.service.obrisiZahtjevPovrat({
          'idkorisnik': Number(localStorage.getItem('idsecuser')),
          'idfirma': Number(localStorage.getItem('firma')),
          'idzahtjevsirovinezag': e.data.idzahtjevsirovinezag
        }).subscribe(res=>{
          if(res.success == true){
            this.dohvatiZahtjeve();
            notify('Uspješno ste obrisali zahtjev/povrat.', 'success', 3000);
          } else {
            notify(res.message, 'error', 3000);
          }
        });
      }else{  }
    });
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      this.odabranoSkladiste_id = e.selectedRowsData[0].poslovnica_idposlovnica;
      this.dohvatiArtikleZaPoslovnicu();

      this.sirovine = [];
      const data = {
        idzahtjevsirovinezag: e.selectedRowsData[0].idzahtjevsirovinezag,
        posifra: e.selectedRowsData[0].po_sifra,
        idfirma: e.selectedRowsData[0].firma_idfirma,
      };
      this.service.dohvatiStavke(data).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.sirovine = res.data;
        }
      });
    }
  }

  dohvatiArtikleZaPoslovnicu(){
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      idposlovnica: this.odabranoSkladiste_id,
    };
    //console.log(podaciZaSlanje);
    this.sviArtikli_poslovnica = [];
    this.sviLotovi_poslovnica = [];
    this.izdatniceService.artiklPopisZaPoslovnicu(podaciZaSlanje).subscribe(res=>{
      //console.log('artiklPopisZaPoslovnicu: ', res);
      if (res.success === true) {
        this.sviArtikli_poslovnica = res.data.artikli;
        this.sviLotovi_poslovnica = res.data.lotovi;
      }else{
        
      }
    });
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onShowing(e: any){
    e.component.option("title", this.naslov);
  }

  onEditingStart(e) {
    //console.log(e);
    this.naslov = 'Uredi stavku';

    if(e.data.artikl_ar_id){
      this.sviLotovi_artikla = [];
      let vazido = '';
      for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
        if (e.data.artikl_ar_id == this.sviLotovi_poslovnica[i].artikl_ar_id) {

          if(this.sviLotovi_poslovnica[i].ar_vazido != null){
            vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
          }else{
            vazido = '';
          }

          this.sviLotovi_artikla.push({
            ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
            ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
            ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
            ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
            ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
            artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
            firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
            lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
            lb_id: this.sviLotovi_poslovnica[i].lb_id,
            lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
            po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
            poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
            ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + ' - Rok: ' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot + ', ' + this.sviLotovi_poslovnica[i].ar_lotstanje_spojeno,
          });
        } 
      }
      //console.log('sviLotovi_artikla: ', this.sviLotovi_artikla);
    }
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == "data") {
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }

  onRowClick(e) {
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onRowUpdated(e) {
    //console.log(e);
    const data = {
      idzahtjevsirovinastavke: e.data.idzahtjevsirovinastavke,
      kolicina: e.data.zss_kolicina_edit,
      arlot: e.data.zss_ar_lot,
    };
    this.service.urediStavku(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješna promjena količine.', 'success', 3000);
      }
    });
  }

  onRowRemoved(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      idzahtjevsirovinastavke: e.data.idzahtjevsirovinastavke
    }
    //console.log(podaciZaSlanje);
    this.service.obrisiStavku(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Stavka uspješno obrisana.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }
}
